import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: [
      {
        path: '/communication/api-mailbox/workbench',
        component: resolve => require(['../components/page/Dashboard.vue'], resolve),
        meta: { title: '工作台' }
      },
      {
        path: '/communication/api-mailbox/leadershipView',
        component: resolve => require(['../components/page/leadershipView.vue'], resolve),
        meta: { title: '领导视图' }
      },
      {
        path: '/communication/api-base/user/user',
        component: resolve => require(['../components/page/BaseTable.vue'], resolve),
        meta: { title: '用户管理' }
      },

      {
        path: '/communication/userManagement/dataPermission',
        component: resolve => require(['../views/userManagement/dataPermission.vue'], resolve),
        meta: { title: '数据权限' }
      },
      {
        path: '/404',
        component: resolve => require(['../components/page/404.vue'], resolve),
        meta: { title: '404' }
      },
      {
        path: '/403',
        component: resolve => require(['../components/page/403.vue'], resolve),
        meta: { title: '403' }
      },

      {
        path: '/communication/api-live',
        component: resolve => require(['../components/page/OnlineInterview.vue'], resolve),
        meta: { title: '在线访谈' }
      },
      /** 意见征集 */
      {
        path: '/communication/api-collect/list',
        component: resolve => require(['../components/page/OpinionCollect.vue'], resolve),
        meta: { title: '征集列表' }
      },
      {
        path: '/communication/api-collect/proposal-classes',
        component: resolve => require(['../components/page/collect/proposalClasses/index.vue'], resolve),
        meta: { title: '意见建议类别' }
      },
      /** 问卷调查 */
      {
        name: "questionPaper",
        path: '/communication/api-questionpaper',
        component: resolve => require(['../components/page/QuestionPaper.vue'], resolve),
        meta: { title: '问卷调查' },
      },
      // {
      //   path: '/communication/api-mailbox/mail/pending',
      //   component: resolve => require(['../views/system/letterAccepted/pending.vue'], resolve),
      //   meta: { title: '待处理' }
      // },
      // {
      //   path: '/communication/api-mailbox/mail/processing',
      //   component: resolve => require(['../views/system/letterAccepted/processing.vue'], resolve),
      //   meta: { title: '处理中' }
      // },
      // {
      //   path: '/communication/api-mailbox/mail/processed',
      //   component: resolve => require(['../views/system/letterAccepted/processed.vue'], resolve),
      //   meta: { title: '已办结' }
      // },
      // {
      //   path: '/communication/api-mailbox/mail/overdue',
      //   component: resolve => require(['../views/system/letterAccepted/overdue.vue'], resolve),
      //   meta: { title: '已超期' }
      // },
      {
        path: '/communication/IntelligentContactCenter',
        component: resolve => require(['../views/IntelligentContactCenter/IntelligentContactCenter.vue'], resolve),
        meta: { title: '智能客服中心' }
      },
      // {
      //   path: '/communication/api-mailbox/mail/newLetter',
      //   component: resolve => require(['../views/system/letterAccepted/newLetter.vue'], resolve),
      //   meta: { title: '新到信件' }
      // },
      // 统计详情页
      {
        path: '/communication/api-questionpaper/questionStatistics',
        meta: { title: '问卷调查' },
        component: resolve => require(['../components/page/questionStatistics.vue'], resolve),
      },
      // 信件模块(信件受理、转办、交办、信件查询内所有)
      {
        path: '/communication/api-mailbox/mail/mail_handle/mail_handle_list',
        component: resolve => require(['../components/page/acceptLetter/main.vue'], resolve),
        meta: { title: '办理' }
      },
      // 新增信件
      {
        path: '/communication/api-mailbox/mail/mail_handle/mail_handle_list/add',
        component: resolve => require(['../components/page/acceptLetter/components/add/addPage.vue'], resolve),
        meta: { title: '新增' }
      },
      // 查看信件
      {
        path: '/communication/api-mailbox/mail/mail_handle/mail_handle_list/edit',
        component: resolve => require(['../components/page/letterOverLook/main.vue'], resolve),
        meta: { title: '详情' },
        name: 'letterEdit'
      },
      {
        path: '/communication/api-mailbox/mail/mail_type/mail_type_destination',
        component: resolve => require(['../components/page/Purpose.vue'], resolve),
        meta: { title: '信件类型' }
      },
      {
        path: '/communication/api-mailbox/mail/mail_type/mail_type_content',
        component: resolve => require(['../components/page/Letterclassify.vue'], resolve),
        meta: { title: '内容分类' }
      },
      {
        path: '/communication/api-mailbox/mail/mail_type/lettersource',
        component: resolve => require(['../components/page/Lettersource.vue'], resolve),
        meta: { title: '信件来源' }
      },
      {
        path: '/communication/api-mailbox/mail/mail_statistic',
        component: resolve => require(['../components/page/Statistical.vue'], resolve),
        meta: { title: '统计' }
      },
      {
        path: '/communication/api-internetAndSupervision',
        component: resolve => require(['../components/page/internetAndSupervision.vue'], resolve),
        meta: { title: '互联网+监督' }
      },
      {
        path: '/communication/api-serverbase/config',
        component: resolve => require(['../components/page/Config.vue'], resolve),
        meta: { title: '配置' }
      },
      // {
      //   path: '/communication/api-mailbox/mail/handover',
      //   component: resolve => require(['../components/page/HandOver.vue'], resolve),
      //   meta: { title: '转办' }
      // },
      // {
      //   path: '/communication/api-mailbox/mail/entrust',
      //   component: resolve => require(['../components/page/Entrust.vue'], resolve),
      //   meta: { title: '交办信件' }
      // },
      {
        path: '/communication/api-mailbox/mail/consulting_management',
        component: resolve => require(['../components/page/ConsultingManagement.vue'], resolve),
        meta: { title: '咨询管理' }
      },
      {
        path: '/communication/api-base/role/role',
        component: resolve => require(['../components/page/Role.vue'], resolve),
        meta: { title: '角色管理' }
      },
      {
        path: '/communication/api-base/res/res',
        component: resolve => require(['../components/page/Resources.vue'], resolve),
        meta: { title: '资源管理' }
      },
      {
        path: '/communication/api-base/dept/dept',
        name: "DepartmentSite",
        component: resolve => require(['../components/page/Department.vue'], resolve),
        meta: { title: '部门管理' }
      },
      {
        path: '/guestarticles',
        component: resolve => require(['../components/page/GuestArticles.vue'], resolve),
        meta: { title: '嘉宾视图' }
      },
      {
        path: '/communication/evaluation/site_management',
        component: resolve => require(['../components/page/EvaluationSiteManage.vue'], resolve),
        meta: { title: '站点管理' }
      },
      {
        path: '/communication/evaluation/progam_manage',
        component: resolve => require(['../components/page/EvaluationProgramManage.vue'], resolve),
        meta: { title: '栏目管理' }
      },
      {
        path: '/communication/evaluation/themeManage',
        component: resolve => require(['../components/page/ThemeManage.vue'], resolve),
        meta: { title: '主题管理' }
      },
      {
        path: '/communication/api-live/administrator',
        component: resolve => require(['../components/page/administrator.vue'], resolve),
        meta: { title: '管理员' }
      },
      {
        path: '/communication/api-live/keyboarder',
        component: resolve => require(['../components/page/keyboarder.vue'], resolve),
        meta: { title: '录入员' }
      },
      {
        path: '/communication/evaluation/chooseSourceSite',
        component: resolve => require(['../components/page/chooseSourceSite.vue'], resolve),
      },
      // 首页
      {
        path: 'index',
        name: 'index',
        meta: {
          auth: true
        },
        component: _import('system/index')
      },

      // 演示页面
      {
        path: 'page1',
        name: 'page1',
        meta: {
          title: '页面 1',
          auth: true
        },
        component: _import('demo/page1')
      },
      {
        path: 'page2',
        name: 'page2',
        meta: {
          title: '页面 2',
          auth: true
        },
        component: _import('demo/page2')
      },
      {
        path: 'page3',
        name: 'page3',
        meta: {
          title: '页面 3',
          auth: true
        },
        component: _import('demo/page3')
      },

      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: _import('system/function/refresh')
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: _import('system/function/redirect')
      }
    ]
  }
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: _import('system/login')
  },
  {
    path: '/login_self',
    name: 'login_self',
    component: _import('system/login/login')
  }
]

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '*',
    name: '404',
    component: _import('system/error/404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]
